import React from "react";
import { useTranslation } from 'react-i18next';

function createDynamicTag(tagName, props, children) {
  const Tag = tagName;

  return <Tag {...props}>{children}</Tag>;
}
function create_list_ptag(item){
  let tag_data;
  let tag_inner;
  if(item.other_option != undefined){
   let innerItem =  item.other_option ;
  
   innerItem.forEach((itemchild, index) => {
    tag_inner = createDynamicTag(itemchild.tag_name,itemchild.props_data,itemchild.title);
    tag_inner = (<>{itemchild.contain_before}{tag_inner}{itemchild.contain_after}</>)
    tag_data = (<>{tag_data}{tag_inner}</>);
});
  }
 let all_data = item.title;

 return (
  <>
      {all_data} {tag_data}
  </>
);
}
const Reinhardbonnke = ({details_pargs}) => {
  const { t, i18n } = useTranslation()
  
  return (

    <section className="about-content-section team-more-content">
            <div className="container">
        <div className="about-content-wrapper d-flex justify-content-between align-items-center">
            <div className="about-content">
              <div>
            {details_pargs.map((item, index) => (
               <p key={item.id || index}> {create_list_ptag(item)}</p>
            ))}</div>
        
            </div>
         </div>
         </div>
  </section>
  );
};

export default Reinhardbonnke;